// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"f0949f42","311":"9988ce43","487":"3479cea5","915":"80b47172"}[chunkId] + ".chunk.css";
};